module.exports = __webpack_public_path__ + "static/2-ad17e3b518b0485fe8eaecd15b147594.jpg";